import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-bg-main-inversion heading-m md:heading-s',
    list: '',
    item: 'shrink-0 overflow-hidden text-ellipsis whitespace-nowrap last:shrink-1',
    separator: 'px-2',
    link: 'link items-center gap-2',
    arrow: 'size-[24px] rotate-90 [&>path]:stroke-white',
    mobile: '',
    type: ''
  },
  variants: {
    isDesktop: {
      true: {
        base: 'font-regular text-bg-main-inversion text-sm'
      }
    },
    small: {
      xs: {
        list: 'xs:flex hidden',
        link: 'max-xs:flex',
        mobile: 'xs:hidden flex'
      },
      sm: {
        list: 'hidden sm:flex',
        link: 'max-sm:flex',
        mobile: 'flex sm:hidden'
      },
      md: {
        list: 'hidden md:flex',
        link: 'max-md:flex',
        mobile: 'flex md:hidden'
      },
      lg: {
        list: 'hidden lg:flex',
        link: 'max-lg:flex',
        mobile: 'flex lg:hidden'
      },
      xl: {
        list: 'hidden xl:flex',
        link: 'max-xl:flex',
        mobile: 'flex xl:hidden'
      },
      '2xl': {
        list: 'hidden 2xl:flex',
        link: 'max-2xl:flex',
        mobile: 'flex 2xl:hidden'
      }
    },
    type: {
      light: {
        base: 'text-white'
      },
      dark: {
        base: 'text-black',
        arrow: '[&>path]:stroke-bg-main-inversion'
      }
    }
  },
  defaultVariants: {
    small: 'sm',
    type: 'light'
  }
});
